module.exports = __webpack_public_path__ + "media/3-12.3e95b774.wav";